export default {
  getXeroAudit: (state) => state.xeroAudit,
};
